import { render, staticRenderFns } from "./LayoutDefault.vue?vue&type=template&id=01278648&scoped=true"
import script from "./LayoutDefault.vue?vue&type=script&lang=js"
export * from "./LayoutDefault.vue?vue&type=script&lang=js"
import style0 from "./LayoutDefault.vue?vue&type=style&index=0&id=01278648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01278648",
  null
  
)

export default component.exports